module.exports = {"330727001":"安文街道","330727002":"新渥街道","330727103":"仁川镇","330727104":"大盘镇","330727105":"方前镇","330727106":"玉山镇","330727107":"尚湖镇","330727108":"冷水镇","330727109":"尖山镇","330727201":"双峰乡","330727203":"双溪乡","330727205":"窈川乡","330727211":"九和乡","330727212":"盘峰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330727.json
// module id = 1001
// module chunks = 0